// extracted by mini-css-extract-plugin
export var divider = "VideoSteps-module_divider__3XGWi";
export var container = "VideoSteps-module_container__3v9Zx";
export var title = "VideoSteps-module_title__3JlaZ";
export var desktop = "VideoSteps-module_desktop__3RGvs";
export var stepsContainer = "VideoSteps-module_stepsContainer__1DF-d";
export var steps = "VideoSteps-module_steps__1YhVp";
export var number = "VideoSteps-module_number__1oEVa";
export var number1 = "VideoSteps-module_number1__2mKE9";
export var number2 = "VideoSteps-module_number2__7RC7Y";
export var number3 = "VideoSteps-module_number3__2xm6j";
export var header = "VideoSteps-module_header__3Yr7w";
export var button = "VideoSteps-module_button__3BRRI";